import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule, DecimalPipe } from '@angular/common';
import { LoadingModule } from '../../shared/loading/loading.module';
import { VesselReviewsBreakdownComponent } from './vessel-reviews-breakdown/vessel-reviews-breakdown.component';
import { CustomerVesselReviewsComponent } from './customer-vessel-reviews/customer-vessel-reviews.component';
import { VesselReviewComponent } from './customer-vessel-reviews/vessel-review/vessel-review.component';
import { VesselReviewsComponent } from './vessel-reviews.component';
import { VesselReviewsDialogComponent } from './vessel-reviews-dialog/vessel-reviews-dialog.component';
import { MainPipe } from '../../shared/pipes/pipes.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { InfiniteScrollModule } from '../../shared/directives/infinite-scroll/infinite-scroll.module';

@NgModule({
  imports: [
    MatIconModule,
    CommonModule,
    MatButtonModule,
    LoadingModule,
    MainPipe,
    MatProgressBarModule,
    InfiniteScrollModule,
  ],
  declarations: [
    VesselReviewsBreakdownComponent,
    CustomerVesselReviewsComponent,
    VesselReviewComponent,
    VesselReviewsComponent,
    VesselReviewsDialogComponent,
  ],
  entryComponents: [],
  exports: [
    VesselReviewsBreakdownComponent,
    CustomerVesselReviewsComponent,
    VesselReviewComponent,
    VesselReviewsComponent,
    VesselReviewsDialogComponent,
  ],
  providers: [],
})
export class VesselReviewsModule {}
